import { useState } from "react";
import { useQueryClient } from "react-query";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-regular-svg-icons";
import { Button, Col, notification, Row, Table, Upload } from "antd";
import dayjs from "dayjs";

import { apiUrl, token } from "../../../../../providers/companyInfo";

export default function PageDataImportTemplateContent(props) {
	const { width } = props;

	const queryClient = useQueryClient();
	const [isLoadingUpload, setIsLoadingUpload] = useState(false);
	const [templateType, setTemplateType] = useState("");

	const uploadProps = {
		name: "file",
		multiple: false,
		showUploadList: false,
		accept: ".xlsx,.xls",
		maxCount: 1,
		action: apiUrl(`api/data_import_history?template_type=${templateType}`),
		headers: { Authorization: token() },
		disabled: isLoadingUpload,
		onChange(info) {
			console.log("info: ", info);

			const { status, response } = info.file;
			if (status === "uploading") {
				setIsLoadingUpload(true);
				return;
			}

			if (status === "done") {
				// Get this url from response in real world.
				setIsLoadingUpload(false);

				if (response.success) {
					notification.success({
						message: "Data Import",
						description: info.file.response.message,
					});

					queryClient.refetchQueries("data_import_history_list");
				} else {
					notification.error({
						message: "Data Import",
						description: info.file.response.message,
					});
					queryClient.refetchQueries("data_import_history_list");
				}
			} else {
				setIsLoadingUpload(false);

				notification.error({
					message: "Data Import",
					description: info.file.response.message,
				});
			}
		},
	};

	const dataSource = [
		// {
		//     id: 1,
		//     priority: 1,
		//     download_template_url: "employee_template.xlsx",
		//     download_template_name: "Employees",
		//     watch_video_url: null,
		//     description: (
		//         <>
		//             Import all your employee's profiles in a quick easy way.
		//             Please ensure each employee's employee ID and Email are
		//             unique.
		//             <br />
		//             <br />
		//             <strong>IMPORTANT:</strong> All columns with asterisk (*)
		//             are required fields, data must be included in these fields.
		//         </>
		//     ),
		// },
		// {
		//     id: 2,
		//     priority: 2,
		//     download_template_url: "student_template.xlsx",
		//     download_template_name: "Students",
		//     watch_video_url: null,
		//     description: (
		//         <>
		//             Import all your student's profiles in a quick easy way.
		//             Please ensure each student's student ID and Email are
		//             unique.
		//             <br />
		//             <br />
		//             <strong>IMPORTANT:</strong> All columns with asterisk (*)
		//             are required fields, data must be included in these fields.
		//         </>
		//     ),
		// },
		{
			id: 3,
			priority: 3,
			download_template_url: "faculty_load_template.xlsx",
			download_template_name: "Faculty Load",
			watch_video_url: null,
			description: (
				<>
					Import all your faculty load in a quick easy way. This Excel file is
					for faculty load. Please make sure that each faculty member has only
					one unique load per subject.
					<br />
					<br />
					<strong>IMPORTANT:</strong> All columns with asterisk (*) are required
					fields, data must be included in these fields.
				</>
			),
		},
		// {
		//     id: 4,
		//     priority: 4,
		//     download_template_url: "student_schedule_template.xlsx",
		//     download_template_name: "Student Schedules",
		//     watch_video_url: null,
		//     description: (
		//         <>
		//             Import all your student schedules in a quick easy way. This
		//             Excel file is for students' schedules. Please ensure each
		//             schedule for each student is unique.
		//             <br />
		//             <br />
		//             <strong>IMPORTANT:</strong> All columns with asterisk (*)
		//             are required fields, data must be included in these fields.
		//         </>
		//     ),
		// },
	];

	const columns = [
		{
			title: "Priority",
			key: "priority",
			dataIndex: "priority",
			align: "center",
			width: 85,
		},
		{
			title: "Download Template",
			key: "download_template",
			render: (_, record) => {
				let download_name = null;

				if (record.download_template_url) {
					download_name =
						record.download_template_url.split(".")[0] +
						"_" +
						dayjs().format("YYYY-MM-DD") +
						"." +
						record.download_template_url.split(".")[1];
				}

				return (
					<Button
						type="link"
						icon={<FontAwesomeIcon icon={faDownload} />}
						href={
							record.download_template_url
								? apiUrl(`templates/${record.download_template_url}`)
								: "#"
						}
						download={download_name ? download_name : null}
					>
						{record.download_template_name}
					</Button>
				);
			},
			align: "center",
			width: 170,
		},
		{
			title: "Description",
			key: "description",
			dataIndex: "description",
			width: 300,
		},
		{
			title: "Upload Your CSV File",
			key: "upload_csv",
			render: (_, record) => {
				return (
					<div className="ml-5!">
						<Upload {...uploadProps}>
							<Button
								type="primary"
								onClick={() => setTemplateType(record.download_template_name)}
								loading={
									isLoadingUpload &&
									templateType === record.download_template_name
								}
								disabled={
									isLoadingUpload &&
									templateType !== record.download_template_name
								}
							>
								Upload
							</Button>
						</Upload>
					</div>
				);
			},
			align: "center",
			width: 165,
		},
	];

	return (
		<Row gutter={[20, 20]}>
			<Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
				<Table
					id="tbl_data_import_templates"
					dataSource={dataSource}
					scroll={{ x: width <= 575 ? "max-content" : "100%" }}
					columns={columns}
				/>
			</Col>
		</Row>
	);
}
